/* eslint-disable*/
import React from "react";
import ReportUsermanual_UserManual from "./UserManual";
import { screen, cleanup } from "@testing-library/react";
import "regenerator-runtime/runtime";
import userEvent from "@testing-library/user-event";
import { act } from "react-dom/test-utils";
import axios from "axios";
import renderTestScreen from "../../../../common/renderTestScreen";
import { t } from "../../../../__mocks__/react-i18next";

describe("UserManual Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(<ReportUsermanual_UserManual />);
    });
  });
  afterEach(cleanup);
  test("is UserManual Loads Successfully", () => {
    expect(screen.getByText("UserManual")).toBeInTheDocument;
  });
  test("Custom Test Cases for UserManual", () => {
    // START_USER_CODE-USER_UserManual_Custom_Test_Case
    // END_USER_CODE-USER_UserManual_Custom_Test_Case
  });
});
describe("Widget Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(<ReportUsermanual_UserManual />);
    });
  });
  afterEach(cleanup);
  test("grpbxCollectionPointManuals(GroupBox Widget) Test Cases", async () => {
    const grpbxCollectionPointManuals = screen.getByTestId(
      "grpbxCollectionPointManuals"
    );
    expect(grpbxCollectionPointManuals.tagName).toBe("BUTTON");
    expect(grpbxCollectionPointManuals.type).toBe("button");
    expect(grpbxCollectionPointManuals.classList).toContain("btn");
  });
  test("Custom Test Cases for grpbxCollectionPointManuals", () => {
    // START_USER_CODE-USER_grpbxCollectionPointManuals_TEST
    // END_USER_CODE-USER_grpbxCollectionPointManuals_TEST
  });
  test("grpbxGeneralManuals(GroupBox Widget) Test Cases", async () => {
    const grpbxGeneralManuals = screen.getByTestId("grpbxGeneralManuals");
    expect(grpbxGeneralManuals.tagName).toBe("BUTTON");
    expect(grpbxGeneralManuals.type).toBe("button");
    expect(grpbxGeneralManuals.classList).toContain("btn");
  });
  test("Custom Test Cases for grpbxGeneralManuals", () => {
    // START_USER_CODE-USER_grpbxGeneralManuals_TEST
    // END_USER_CODE-USER_grpbxGeneralManuals_TEST
  });
});
